import { takeEvery, take, select, call, put } from "redux-saga/effects"

// Types
import MappingRisksTypes from "ContainersForm/MappingRisk/types"

// Saga
import { responseTypeIsError, responseTypeIsSuccess } from "Containers/App/saga"

// Actions
import { getHistoryMappingSuccess } from "ContainersForm/MappingRisk/actions"

// Selectors
import { selectCurrentToken } from "Containers/Login/selectors"

// Utils
import { postCors, getCors } from "Utils/rulesCors"
import { config } from "Utils/config"
import request from "Utils/request"

function* getHistory({ payload }) {
  const token = yield select(selectCurrentToken)

  try {
    const response = yield call(
      request,
      `${config?.FORM_BACK_URL}/frozenRisksMappings/${payload?.mappingRiskId}`,
      getCors({ token })
    )

    if (responseTypeIsError(response)) {
      console.error(`[route] => /frozenRisksMappings => ERROR POST => `, response)
    } else {
      yield put(getHistoryMappingSuccess(response?.body))
    }
  } catch (err) {
    console.error(`[route] => /frozenRisksMappings => ERROR POST => `, err)
  }
}

function* postHistory({ payload }) {
  const token = yield select(selectCurrentToken)

  console.log("payload", payload)
  try {
    const response = yield call(
      request,
      `${config?.FORM_BACK_URL}/frozenRisksMappings`,
      postCors(payload, { token })
    )

    if (responseTypeIsError(response)) {
      console.error(`[route] => /frozenRisksMappings => ERROR POST => `, response)
    } else {
      // yield put(getPackagesAction())
    }
  } catch (err) {
    console.error(`[route] => /frozenRisksMappings => ERROR POST => `, err)
  }
}

// ***************************** //
//              Sagas            //
// ***************************** //
function* mappingRiskSaga() {
  yield takeEvery(MappingRisksTypes.POST_HISTORY_MAPPING, postHistory)
  yield takeEvery(MappingRisksTypes.GET_HISTORY_MAPPING, getHistory)
}

export default mappingRiskSaga
